


















































































































































































































































































































































































































































import { Actor } from '@/data/models/actor.model';
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { ListService } from '@/data/services/list.service';
import { CrudService } from '@/data/services/crud.service';
import { AttachService } from '@/data/services/attach.service';
import { Attach, AttachSize } from '@/data/models/attach.model';
import { cloneDeep } from 'lodash';
import AttoreQualifications from './AttoreQualifications.vue';
import { Comune } from '@/data/models/comune.model';
import { Search } from '@/data/models/search.model';
import { ClassType } from 'class-transformer/ClassTransformer';
import CodiceFiscale  from 'codice-fiscale-js';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider,
		AttoreQualifications
	}
})
export default class AttorePersonalData extends Vue {
	@Inject('ListService') listService!: ListService;
	@Inject('CrudService') actorCrudService!: CrudService<Actor>;
	@Inject('CrudService') attachCrudService!: CrudService<Attach>;
	@Inject('AttachService') attachService!: AttachService;

	@Prop() actor!: Actor;

	personaldataopen = true;
	moreinfoopen = false;
	noteopen = false;
	photoopen = false;
	qualificationopen = false;
	uploading = false;
	editable?: boolean = true;
	idDocuments: string[] = [];
	studyLevels: string[] = [];

	file: any = null; //photo

	advancedSearchComune = new Search('comuni');
	comuneClass: ClassType<Comune> = Comune;
	selectedComune: Comune = new Comune();

	constructor() {
		super();
		
	}

	mounted() {
		this.idDocuments = [this.$t('idcard').toString(), this.$t('drivelicense').toString(), this.$t('passport').toString()];
		this.studyLevels = [this.$t('primaryschool').toString(), 
			this.$t('middleschool').toString(), this.$t('highschool').toString(),
			this.$t('bachelordegree').toString(), this.$t('masterdegree').toString()];
		
	}

	@Watch('actor') 
	onActorChange() {
		if(this.actor?.photo) {
			this.photoopen = true;
			this.loadActorImage();
		}
		this.selectedComune = {
			id: 0,
			pid: 0,
			descrizione: this.actor!.cityofbirth
		};
	}

	loadActorImage() {
		this.attachService.downloadImage(this.actor!.photo as string, AttachSize.LG)
			.then((response: any) => {
				if (response.data && response.status === 200) {
					this.$set(this.actor!, 'previewurl', URL.createObjectURL(response.data));
				}
			}).catch(({ data }) => {
				if (data) {
					this.$buefy.notification.open({
						message: data.msg || data.internal,
						type: 'is-danger',
					});
				}
			});
	}

	saveActorLogo(actor: Actor) {
		const formData = new FormData();
		formData.append('file', this.file);
		this.uploading = true;
		this.attachCrudService.uploadEntity(Attach, 'actor', actor!.id, formData)
			.then((attach: Attach) => {
				const tmp = cloneDeep(actor);
				tmp!.photo = attach.opaqueid;
				this.actorCrudService.saveEntity(Actor, 'actor', tmp).then(result => {
					this.file = null;
					this.loadActorImage();
					this.$emit('updateActor', result);
					this.$buefy.notification.open({
						message: this.$t('success-save') as string,
						type: 'is-success',
					});
				}).finally(() => this.uploading = false);
			})
			.catch((error) => {
				this.uploading = false,
				this.$buefy.notification.open({
					message: error.msg,
					type: 'is-danger',
				});
			});
	}

	updateCF(comune?: Comune) {
		if (comune && comune.descrizione) {
			this.actor.cityofbirth = comune.descrizione;
		}
		if(this.actor.name && this.actor.surname && this.actor?.cityofbirth && this.actor.dob && this.actor.gender) {
			const cf = new CodiceFiscale({
				name: this.actor.name,
				surname: this.actor.surname,
				gender: this.actor.gender?.toUpperCase(),
				day: this.actor.dob.getDate(),
				month: this.actor.dob.getMonth() + 1,
				year: this.actor.dob.getFullYear(),
				birthplace: this.actor.cityofbirth
			});
			this.actor.cf = cf.cf;
		}
	}
    
	submit() {
		const call = (this.actor!.id) ? 
			this.actorCrudService.saveEntity(Actor, 'actor', this.actor) : 
			this.actorCrudService.createEntity(Actor, 'actor', this.actor);
		call.then(result => {
			this.$emit('updateActor', result);
			if(this.file) {
				this.saveActorLogo(result);
				return;
			} else {
				this.$buefy.notification.open({
					message: this.$t('success-save') as string,
					type: 'is-success',
				});
			}
		});
	}
	
}
